import React from "react";
import { Empty, Tag, Typography } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import Table from "../Tables/Table";

const { Text } = Typography;

const FacultiesTab = ({ institution }) => {
  const { faculties = [] } = institution;

  if (faculties.length === 0) {
    return (
      <div className="py-8">
        <Empty description="No faculties found for this institution." />
      </div>
    );
  }

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 300,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Faculty Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Text>{text}</Text>,
    },
  ];

  return (
    <div className="pt-5">
      <Table
        rows={faculties.map((f) => ({ ...f, key: f.id }))}
        columns={columns}
        pagination={{ pageSize: 5 }}
        bordered
        size="middle"
      />
    </div>
  );
};

export default FacultiesTab;
